import { classNames } from "primereact/utils"
import type { FC } from "react"

type OverlayVariant = "default" | "plain" | "strong"

const SheetOverlay: FC<Props> = ({ imageSrc, variant = "default", fallbackImage, isLoading = false }) => {
  const config = {
    default: {
      imageOpacity: "opacity-[62%]",
      showGradient: true,
    },
    plain: {
      imageOpacity: "opacity-100",
      showGradient: false,
    },
    strong: {
      imageOpacity: "opacity-100",
      showGradient: true,
    },
  }[variant]

  return (
    <div className="fixed inset-0 z-0 h-full w-full">
      <div className={classNames("h-full w-full", config.imageOpacity)}>
        <img
          src={isLoading && fallbackImage ? fallbackImage : imageSrc}
          alt="Background image"
          className="h-full w-full object-center origin-top scale-x-[1.5]  md:!object-cover md:!scale-100 md:!origin-center"
          loading="eager"
          decoding="sync"
          onError={(e) => {
            if (fallbackImage) e.currentTarget.src = fallbackImage
          }}
        />
      </div>
      {config.showGradient && (
        <div className="absolute inset-0 h-full w-full bg-gradient-to-b from-[var(--color-overlay-top-stop)] to-[var(--color-overlay-bottom-stop)] opacity-100" />
      )}
    </div>
  )
}

type Props = {
  imageSrc?: string
  fallbackImage?: string
  isLoading?: boolean
  variant?: OverlayVariant
}

export { SheetOverlay }
